"use strict";

canopyPublic.config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	$stateProvider.state("public.reset-request", {
		url: "/reset-request",
		controller: "ResetRequestController",
		templateUrl: Luma.paths.context + "/system/mantle/components/canopyPublic/states/reset-request/reset-request.template.html"
	});
}]);
